import { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';

const FilterMenu = (props) => {
  const { filters } = props; // Get the dynamic filters array
  const cardWidth = 500;
  const phoneSize = 500;
  const menu = useRef(null);
  const [offset, setOffset] = useState(0);
  const [direction, setDirection] = useState('left');

  useEffect(() => {
    const currentX = menu.current.getBoundingClientRect().x;
    const screenSize = window.innerWidth;
    if (cardWidth + currentX > screenSize) {
      const offsetValue = screenSize - (cardWidth + currentX);
      if (offsetValue < 0) {
        setOffset(offsetValue);
      } else {
        setOffset((prevValue) => prevValue + offsetValue);
        setDirection('left');
      }
    }
    if (screenSize <= phoneSize) {
      setOffset((prevValue) => prevValue / 2);
    }
  }, [menu.current]);

  return (
    <div ref={menu} style={{ [direction]: `${offset}px` }} className="filter-card">
      <div className="card-header">
        <h4 className="drs-card-header-title">{props.intl.formatMessage({ id: 'filters' })}</h4>
        <button className="close float-right" onClick={props.handleShowHide}>
          <span>&times;</span>
        </button>
      </div>
      <div className="card-body drs-body-padding">
        <div className="filter-card-body">
          {filters.map((filter, index) => {
            const FilterComponent = filter.component;
            return <FilterComponent key={index} {...filter.props} />;
          })}
        </div>
      </div>
      <div className="card-body drs-body-padding--footer"></div>
    </div>
  );
};

export default injectIntl(FilterMenu);
